module.exports = __webpack_public_path__ + "static/escape-from-freedom-883edb2d1c92da4b7380db3fa6a53bea.jpg";